import React, { Component } from "react";

import {
  EVOUCHER_UPDATE_LOGS
}                           from "actions/const";

import View                 from "./View.js";

export default class FormContainer extends Component {
  render () {
    let {
      EVoucherUpdateLogs
    } = this.props;

    let {
      formType
    } = EVoucherUpdateLogs;

    switch (formType.toUpperCase()) {
      case "VIEW":
        return <View {...this.props}/>;
        break;
      default:
        return "";
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      EVOUCHER_UPDATE_LOGS,
      {
        selectedData: null,
        formType: "",
        formTitle: ""
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/EVoucherUpdateLogs/FormContainer/index.js